module.exports = __webpack_public_path__ + "static/media/kaymo_logo_2020.aab9b721.svg";